import React, { useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Card, Container, Page } from './styles';

import Tooltip from '@material-ui/core/Tooltip';
import ArrowBack from '@material-ui/icons/ArrowBack';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import NotesIcon from '@material-ui/icons/Notes';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { BsSortAlphaDown, BsSortAlphaUpAlt } from 'react-icons/bs';
import { HiOutlineRefresh } from 'react-icons/hi';

import PersonIcon from '@material-ui/icons/Person';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';

// fucoes
import { differenceInDays } from 'date-fns';

// // confirmacao
import { toast } from 'react-toastify';
import Dialogoadicionarsupervisor from '../../../components/Dialogoadicionarsupervisor';
import Dialogoconfirmacao from '../../../components/Dialogoconfirmacao';
import Dialogoverificaralteracao from '../../../components/Dialogoverificaralteracao';

// // chatbox
import { Badge } from '@material-ui/core';
import Chatbox from '../../../components/Chatbox';

// API de EndPoints
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import {
  DELETE_RESPONSIBLES,
  GET_PROJECTS_BY_INTEGRATOR,
  PATCH_FINISHED_PROJECT,
  PATCH_PROJECTS_BY_ID,
  SET_CANCEL_PAYMENT_ID,
  SET_PAYMENT_ID,
} from '../../../services/endpoints';

import SimpleBackdrop from '../../../components/Backdrop';
import { listetapas } from '../../../config';

// contexto
import { mask } from 'remask';
import BaseDialogEditProject from '../../../components/BaseDialogEditProject';
import BaseDialogShowProject from '../../../components/BaseDialogShowProject';
import { useAuth } from '../../../contexts/AuthContext';
import { projects, ufs } from '../../../utils/constants';

import { clean, collator, strip, toTime } from '../../../utils/orderList';

function Projetos() {
  // Loading
  const [showbackdrop, setShowbackdrop] = useState(false);
  const { user } = useAuth();
  const isAdmin = user?.role === 'ADMINISTRADOR' || user?.role === 'GERENTE';

  // Dialogo de suspensão - confirmação
  const [showconf, setShowconf] = useState({
    id: null,
    status: false,
    width: 'sm',
    title: 'Confirmar',
    description: 'Deseja realmente suspender este projeto?',
    btn_conf: 'Sim',
    btn_cancel: 'Não',
    delete: true,
    dados: '',
  });

  //Dialogo desvincular supervisor
  const [showconfdesvincular, setShowconfdesvincular] = useState({
    status: false,
    width: 'sm',
    title: 'Confirmar',
    description: 'Deseja realmente desvincular este supervisor?',
    btn_conf: 'Sim',
    btn_cancel: 'Não',
    delete: true,
    dados: '',
  });

  // Variável de filtro
  const [filter, setFilter] = useState({
    type: '',
    value: '',
    dig: '',
  });

  // Quantidade de listagem de cards
  const [listidx, setListidx] = useState(3);

  // Ordenador
  const [order, setOrder] = useState('');

  // Solicitar Mudança
  const [solicitarmud, setSolicitarmud] = useState({
    status: false,
    dados: '',
  });

  const [editProject, setEditProject] = useState({
    status: false,
    dados: '',
  });

  // Variável de edição
  const [viewedit, setViewedit] = useState({
    status: false,
    dados: '',
    dados_proj: '',
  });

  // Variável de visualizar projeto
  const [viewproject, setViewproject] = useState({
    status: false,
    dados: '',
  });

  // Modal de cadastro de Supervisor
  const [viewcadastrarsupervisor, setViewcadastrarsupervisor] = useState({
    status: false,
    dados: '',
  });

  // Listagem de Projetos
  const [listprojects, setListProjects] = useState([]);

  // Busca do ID da Companhia via url
  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();

  const handleProjectPixUpdated = (projectId, newCode) => {
    setListProjects((prev) =>
      prev.map((p) => (p.id === projectId ? { ...p, pix_code: newCode } : p))
    );
  };

  const handleProjectPaymentUpdated = (projectId, receiptId, isPaid) => {
    setListProjects((prev) =>
      prev.map((p) =>
        p.id === projectId
          ? {
              ...p,
              receipts: (p.receipts || []).map((r) =>
                r.id === receiptId ? { ...r, is_paid: isPaid } : r
              ),
            }
          : p
      )
    );
  };

  const sortByCreatedAsc = (a, b) =>
    new Date(a.created_at) - new Date(b.created_at);
  const getLastReceipt = (proj) =>
    (proj?.receipts || []).length
      ? [...proj.receipts].sort(sortByCreatedAsc)[0]
      : null;

  // ordem cronológica
  const maisatual = (a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  };

  const handleFilter = (dado) => {
    if (!filter.type || !filter.value) return true;

    if (filter.type === 'name') {
      return (
        !!dado.client_name &&
        strip(dado.client_name).includes(strip(filter.value))
      );
    } else if (filter.type === 'cpf') {
      return (
        !!dado.client_cpf &&
        dado.client_cpf
          .replace(/\D/g, '')
          .includes(filter.value.replace(/\D/g, ''))
      );
    } else if (filter.type === 'cnpj') {
      return (
        !!dado.client_cnpj &&
        dado.client_cnpj
          .replace(/\D/g, '')
          .includes(filter.value.replace(/\D/g, ''))
      );
    } else if (filter.type === 'suspended_projects') {
      return !!dado.suspended;
    } else if (filter.type === 'state') {
      return !!dado.state && strip(dado.state).includes(strip(filter.value));
    } else if (filter.type === 'delayed_projects') {
      return dado.process >= dado.max_process && dado.suspended === false;
    } else if (filter.type === 'project_type' && filter.value) {
      return dado.type === filter.value;
    }
    return true;
  };

  const handleFilterValue = (event) => {
    if (filter.type === 'cpf') {
      setFilter({
        ...filter,
        value: mask(event.target.value, '999.999.999-99'),
      });
    } else if (filter.type === 'cnpj') {
      setFilter({
        ...filter,
        value: mask(event.target.value, '99.999.999/9999-99'),
      });
    } else {
      setFilter({ ...filter, value: event.target.value });
    }
  };

  const isAdminFilter = (dado) => {
    if (isAdmin) return true;

    if (dado?.responsibles?.sort(maisatual)[0]?.user?.id === user?.user?.id)
      return true;
  };

  const filterProjects = useMemo(() => {
    const base = (listprojects ?? [])
      .filter(isAdminFilter)
      .filter(handleFilter);
    return base.sort((a, b) => {
      switch (order) {
        case 'AZ':
          return collator.compare(clean(a.client_name), clean(b.client_name));
        case 'ZA':
          return collator.compare(clean(b.client_name), clean(a.client_name));
        case 'primeiros':
          return toTime(b.created_at) - toTime(a.created_at);
        case 'ultimos':
          return toTime(a.created_at) - toTime(b.created_at);
        default:
          return 0;
      }
    });
  }, [listprojects, order, filter]);

  React.useEffect(() => {
    if (listprojects.length > 0) {
      const queryParams = new URLSearchParams(location.search);
      const projectIdFromUrl = queryParams.get('projectId');

      if (projectIdFromUrl) {
        const projectToOpen = listprojects.filter(
          (project) => project.id == projectIdFromUrl
        );

        if (projectToOpen) {
          setViewproject({ status: true, dados: projectToOpen[0] });
          history.replace(location.pathname);
        }
      }
    }
  }, [listprojects, location, history]);

  React.useEffect(() => {
    let params = {
      is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
    };

    GET_PROJECTS_BY_INTEGRATOR(id, setListProjects, setShowbackdrop, params);
  }, [id, user?.role]);

  function statusProgress(value) {
    switch (value) {
      case listetapas[0]:
        return ((1 * 100) / 6).toFixed(2);
      case listetapas[1]:
        return ((2 * 100) / 6).toFixed(2);
      case listetapas[2]:
        return ((3 * 100) / 6).toFixed(2);
      case listetapas[3]:
        return ((4 * 100) / 6).toFixed(2);
      case listetapas[4]:
        return ((5 * 100) / 6).toFixed(2);
      case listetapas[5]:
        return ((6 * 100) / 6).toFixed(2);

      default:
        return 0;
    }
  }

  const sendWhatsapp = (phone) => {
    const clearedPhone = phone.replace(/\D/g, '');
    const url = `https://wa.me/${clearedPhone}`;

    window.open(url, '_blank');
  };

  return (
    <Container>
      <Page>
        <header>
          <h1>Projetos do Integrador</h1>
          <span>
            Confira o andamento dos projetos do Integrador cadastrados no
            sistema.
          </span>
        </header>
        <content>
          <div className="div__fieldFilter">
            <div className="div__filters">
              <div className="div__actionButtons">
                <button
                  className="primary-button-style"
                  onClick={() => {
                    history?.push(`/integradores`);
                  }}
                >
                  <ArrowBack /> Voltar
                </button>

                <button
                  className="secondary-button-style"
                  onClick={() => {
                    let params = {
                      is_approved:
                        user?.role === 'ADMINISTRADOR' ? true : false,
                    };

                    GET_PROJECTS_BY_INTEGRATOR(
                      id,
                      setListProjects,
                      setShowbackdrop,
                      params
                    );
                  }}
                >
                  <HiOutlineRefresh /> Atualizar
                </button>
              </div>
              <div className="div__contFieldFilter">
                <div className="div__contSelectFilters">
                  <select
                    onChange={(event) =>
                      setFilter({
                        ...filter,
                        type: event.target.value,
                        value: '',
                        dig: '',
                      })
                    }
                    value={filter.type}
                    style={{ maxWidth: 200 }}
                  >
                    <option value="" selected>
                      Filtro
                    </option>
                    <option value="name">Cliente</option>
                    <option value="cpf">CPF</option>
                    <option value="cnpj">CNPJ</option>
                    <option value="project_type">Tipo</option>
                    {/* <option value="state">Estado</option> */}
                    {/* <option value="concessionaria">Concessionária</option> */}
                    {/* <option value="open_projects">Projetos em aberto</option> */}
                    {/* <option value="delayed_projects">Projetos atrasados</option> */}
                    {/* <option value="completed_projects">Projetos finalizados</option>
                <option value="suspended_projects">Projetos suspensos</option> */}
                  </select>

                  <input
                    placeholder={
                      filter.type === 'name'
                        ? 'Digite o nome'
                        : filter.type === 'email'
                        ? 'Digite o E-mail'
                        : filter.type === 'cpf'
                        ? 'Digite o CPF'
                        : filter.type === 'cnpj'
                        ? 'Digite o CNPJ'
                        : ' - '
                    }
                    value={filter.value}
                    disabled={!filter.type}
                    onChange={handleFilterValue}
                    style={{
                      display:
                        filter.type === 'name' ||
                        filter.type === 'email' ||
                        filter.type === 'cpf' ||
                        filter.type === 'cnpj'
                          ? 'block'
                          : 'none',
                    }}
                  />

                  <select
                    required
                    name="state"
                    style={{
                      display: filter.type === 'state' ? 'block' : 'none',
                    }}
                    value={filter.value}
                    onChange={handleFilterValue}
                  >
                    <option value="" disabled>
                      Escolha o estado
                    </option>
                    {ufs.map((uf, idx) => (
                      <option value={uf} key={idx}>
                        {uf}
                      </option>
                    ))}
                  </select>

                  {filter.type === 'project_type' && (
                    <select
                      className="input-custom-style"
                      name="project_type"
                      value={filter.value}
                      onChange={handleFilterValue}
                    >
                      <option value="" disabled selected>
                        Escolha o tipo
                      </option>

                      {Object.entries(projects).map(([key, value]) => {
                        return (
                          <option key={key} value={key}>
                            {value}
                          </option>
                        );
                      })}
                    </select>
                  )}
                </div>
              </div>
            </div>

            <div className="div__order">
              <button
                className={order === 'AZ' ? 'btn__esq btn__ativ' : 'btn__esq'}
                onClick={() => (order === 'AZ' ? setOrder('') : setOrder('AZ'))}
              >
                <BsSortAlphaDown style={{ fontSize: '1.4rem' }} />
              </button>
              <button
                className={order === 'ZA' ? 'btn_meio btn__ativ' : 'btn_meio'}
                onClick={() => (order === 'ZA' ? setOrder('') : setOrder('ZA'))}
              >
                <BsSortAlphaUpAlt style={{ fontSize: '1.4rem' }} />
              </button>

              <button
                className={
                  order === 'primeiros' ? 'btn_meio btn__ativ' : 'btn_meio'
                }
                onClick={() =>
                  order === 'primeiros' ? setOrder('') : setOrder('primeiros')
                }
              >
                Recentes
              </button>
              <button
                className={
                  order === 'ultimos' ? 'btn__dir btn__ativ' : 'btn__dir'
                }
                onClick={() =>
                  order === 'ultimos' ? setOrder('') : setOrder('ultimos')
                }
              >
                Antigos
              </button>
            </div>
          </div>
          <div className="div__deck">
            {filterProjects?.slice(0, listidx).map((proj) => (
              <Card
                key={proj?.id}
                progress={differenceInDays(
                  new Date(),
                  new Date(proj?.stages.sort(maisatual)[0]?.created_at)
                )}
                projetct_process={statusProgress(
                  proj?.stages?.sort(maisatual)[0]?.title
                )}
                max_process={differenceInDays(
                  new Date(proj?.stages.sort(maisatual)[0]?.deadline),
                  new Date(proj?.stages.sort(maisatual)[0]?.created_at)
                )}
                suspended={proj?.suspended}
                finished={proj?.finished_at ? true : false}
              >
                <div className="div__name">
                  {!proj.refused ? (
                    !proj.finished_at ? (
                      proj.suspended ? (
                        <span
                          style={{
                            textAlign: 'left',
                            color: 'gray',
                            marginBottom: '0.5rem',
                          }}
                        >
                          Projeto suspenso
                        </span>
                      ) : (
                        <span
                          style={{
                            textAlign: 'left',
                            color: 'var(--primary2)',
                            marginBottom: '0.5rem',
                          }}
                        >
                          Projeto em aberto
                        </span>
                      )
                    ) : (
                      <span
                        style={{
                          textAlign: 'left',
                          color: 'gray',
                          marginBottom: '0.5rem',
                        }}
                      >
                        {proj?.stages.sort(maisatual)[0]?.title ===
                        '5 - Projeto aprovado'
                          ? 'Projeto aprovado'
                          : proj?.stages.sort(maisatual)[0]?.title ===
                            '7 - Projeto reprovado'
                          ? 'Projeto reprovado'
                          : 'Projeto finalizado'}
                      </span>
                    )
                  ) : (
                    <span
                      style={{
                        textAlign: 'left',
                        color: 'var(--delete)',
                        marginBottom: '0.5rem',
                      }}
                    >
                      Projeto recusado
                    </span>
                  )}

                  <span className="tag-whatsapp">
                    {proj?.receipts[0]?.is_whatsapp && (
                      <p>Negociação pelo Whatsapp</p>
                    )}
                  </span>

                  <span className="tag">
                    {proj?.responsibles.length !== 0 ? (
                      <>
                        <p>
                          {proj?.responsibles
                            .sort(maisatual)[0]
                            ?.user?.name.split(' ')
                            .map((item, idx) => idx < 2 && item + ' ')}{' '}
                          - {proj?.responsibles.sort(maisatual)[0]?.user?.role}
                        </p>
                        {!proj?.finished_at && isAdmin && (
                          <Tooltip
                            placement="bottom-start"
                            title="Remover supervisor"
                          >
                            <HighlightOffIcon
                              style={{
                                color: 'var(--delete)',
                                cursor: 'pointer',
                              }}
                              onClick={() =>
                                setShowconfdesvincular({
                                  ...showconf,
                                  status: true,
                                  width: 'sm',
                                  title: 'Confirmar',
                                  description: `Deseja realmente desvincular o supervisor ${
                                    proj?.responsibles.sort(maisatual)[0]?.user
                                      ?.name
                                  } do projeto ${proj.client_name}?`,
                                  btn_conf: 'Sim',
                                  btn_cancel: 'Não',
                                  delete: false,
                                  dados: proj,
                                  type: 'DELETE_RESPONSIBLES',
                                })
                              }
                            />
                          </Tooltip>
                        )}
                      </>
                    ) : (
                      <p
                        style={{
                          backgroundColor: 'var(--gray)',
                          color: 'var(--primary)',
                          cursor: 'pointer',
                        }}
                        onClick={() =>
                          setViewcadastrarsupervisor({
                            status: true,
                            dados: proj,
                          })
                        }
                      >
                        Adicionar Supervisor
                      </p>
                    )}
                  </span>

                  <h4>
                    <PersonIcon /> {proj?.client_name}
                  </h4>
                  {proj?.client_cpf && <span>CPF: {proj?.client_cpf}</span>}
                  {proj?.client_cnpj && <span>CNPJ: {proj?.client_cnpj}</span>}
                  <span>
                    {proj?.dealer?.name} - {proj?.dealer?.state}
                  </span>
                  <span>Tipo: {projects[proj.type]}</span>

                  <div className="div__options">
                    {!proj.refused && !proj?.finished_at && (
                      <Tooltip
                        placement="bottom-start"
                        title="Confirmar edição"
                      >
                        <Badge
                          overlap="circular"
                          badgeContent={
                            proj?.change_requests?.filter(
                              (change) => change.resolved === false
                            ).length
                          }
                          // showZero
                          style={{ marginTop: '-0.4rem' }}
                          color="secondary"
                        >
                          <button
                            onClick={() =>
                              setViewedit({
                                status: true,
                                dados: proj.change_requests,
                                dados_proj: proj,
                              })
                            }
                          >
                            <AssignmentTurnedInIcon />
                          </button>
                        </Badge>
                      </Tooltip>
                    )}

                    {!proj.refused &&
                      !proj?.finished_at &&
                      !proj.suspended &&
                      proj?.stages?.length >= 1 && (
                        <Tooltip
                          placement="bottom-start"
                          title="Adicionar etapa ao projeto"
                        >
                          <button
                            onClick={() =>
                              setSolicitarmud({ status: true, dados: proj })
                            }
                          >
                            <NotesIcon />
                          </button>
                        </Tooltip>
                      )}

                    {!proj.refused && proj.stages?.length <= 0 && (
                      <Tooltip
                        placement="bottom-start"
                        title="Confirmar Recepção do projeto"
                      >
                        <button
                          onClick={() =>
                            setSolicitarmud({ status: true, dados: proj })
                          }
                        >
                          <PlaylistAddCheckIcon />
                        </button>
                      </Tooltip>
                    )}

                    <Tooltip placement="bottom-start" title="Editar projeto">
                      <button
                        onClick={() =>
                          setEditProject({ status: true, dados: proj })
                        }
                      >
                        <EditOutlinedIcon />
                      </button>
                    </Tooltip>

                    <Tooltip
                      placement="bottom-start"
                      title="Visualizar informações de projeto"
                    >
                      <Badge
                        overlap="circular"
                        badgeContent={
                          proj?.pendencies?.filter(
                            (change) =>
                              change.customer_comment &&
                              change.resolved === false
                          ).length
                        }
                        // showZero
                        style={{ marginTop: '-0.4rem' }}
                        color="secondary"
                      >
                        <button
                          onClick={() =>
                            setViewproject({ status: true, dados: proj })
                          }
                        >
                          <VisibilityOutlinedIcon />
                        </button>
                      </Badge>
                    </Tooltip>
                    {proj?.receipts[0]?.is_whatsapp && (
                      <Tooltip
                        placement="bottom-start"
                        title="Negociar pelo WhatsApp"
                      >
                        <button
                          className={
                            !proj?.integrators[0]?.integrator?.phone_numbers[0]
                              ?.is_whatsapp && 'whatsappButton_disabled'
                          }
                          onClick={() => {
                            if (
                              proj?.integrators[0]?.integrator?.phone_numbers[0]
                                ?.is_whatsapp
                            ) {
                              sendWhatsapp(
                                proj?.integrators[0]?.integrator
                                  ?.phone_numbers[0]?.number
                              );

                              return;
                            }

                            toast.warn(
                              'O número que o integrador cadastrou não é WhatsApp. Entre em contato de outra maneira.'
                            );
                          }}
                        >
                          <WhatsAppIcon />
                        </button>
                      </Tooltip>
                    )}
                    {!proj?.finished_at && proj.suspended && (
                      <Tooltip
                        placeholder="bottom-start"
                        title="Retomar projeto"
                      >
                        <button
                          onClick={() =>
                            setShowconf({
                              ...showconf,
                              status: true,
                              width: 'sm',
                              title: 'Confirmar',
                              description: `Deseja realmente retomar o projeto de ${proj.client_name}?`,
                              btn_conf: 'Sim',
                              btn_cancel: 'Não',
                              delete: false,
                              dados: proj,
                              type: 'PATCH_PROJECTS_BY_ID',
                            })
                          }
                        >
                          <PlayArrowIcon />
                        </button>
                      </Tooltip>
                    )}
                    {!proj.refused && !proj?.finished_at && !proj.suspended && (
                      <Tooltip
                        placement="bottom-start"
                        title="Suspender projeto"
                      >
                        <button
                          className="button_delete"
                          onClick={() =>
                            setShowconf({
                              ...showconf,
                              status: true,
                              width: 'sm',
                              title: 'Confirmar',
                              description: `Deseja realmente suspender o projeto de ${proj.client_name}?`,
                              btn_conf: 'Sim',
                              btn_cancel: 'Não',
                              delete: false,
                              dados: proj,
                              type: 'PATCH_PROJECTS_BY_ID',
                            })
                          }
                        >
                          <StopIcon />
                        </button>
                      </Tooltip>
                    )}
                  </div>
                </div>
                <div className="div__total_project_power">
                  <h4>
                    {proj.total_project_power &&
                      `${proj.total_project_power}kWp`}
                  </h4>
                  <div className="div__sub_total_project_power">
                    <span>Início:</span>{' '}
                    <p style={{ margin: '0rem' }}>
                      {new Date(proj.created_at).toLocaleDateString('pt-BR')}
                    </p>
                  </div>
                  <div className="div__sub_total_project_power">
                    {!proj?.finished_at ? (
                      <span>Previsão de Conclusão:</span>
                    ) : (
                      <span>Finalizado em:</span>
                    )}{' '}
                    {!proj.suspended ? (
                      proj.stages?.length > 0 || proj.finished_at ? (
                        <p style={{ margin: '0rem' }}>
                          {new Date(
                            proj.finished_at
                              ? proj.finished_at
                              : proj.stages && proj.stages[0]?.deadline
                          ).toLocaleDateString('pt-BR')}
                        </p>
                      ) : (
                        <p>--/--/----</p>
                      )
                    ) : (
                      <p>--/--/----</p>
                    )}
                  </div>
                  <div className="div__options">
                    {!proj.refused && !proj?.suspended && (
                      <Tooltip
                        placement="bottom-start"
                        title={
                          !proj.finished_at
                            ? 'Finalizar projeto'
                            : 'Reativar projeto'
                        }
                      >
                        <button
                          className={
                            !proj.finished_at
                              ? 'button_project button_cancel_project'
                              : 'button_project'
                          }
                          onClick={() =>
                            !proj.finished_at
                              ? setShowconf({
                                  ...showconf,
                                  status: true,
                                  width: 'sm',
                                  title: 'Confirmar',
                                  description: `Deseja realmente finalizar o projeto de ${proj.client_name}?`,
                                  btn_conf: 'Sim',
                                  btn_cancel: 'Não',
                                  delete: true,
                                  dados: proj,
                                  type: 'SET_FINISH_PROJECT',
                                })
                              : setShowconf({
                                  ...showconf,
                                  status: true,
                                  width: 'sm',
                                  title: 'Confirmar',
                                  description: `Deseja realmente reativar o projeto de ${proj.client_name}?`,
                                  btn_conf: 'Sim',
                                  btn_cancel: 'Não',
                                  delete: false,
                                  dados: proj,
                                  type: 'SET_OPEN_PROJECT',
                                })
                          }
                        >
                          <AssignmentOutlinedIcon />{' '}
                          {!proj.finished_at ? 'Finalizar' : ' Reabrir'}
                        </button>
                      </Tooltip>
                    )}
                  </div>
                </div>

                <div className="div__status">
                  <div className="barra_progresso">
                    <span />{' '}
                    <div>
                      <h4>Status do Projeto</h4>
                    </div>
                  </div>
                  <div className="barra_progresso">
                    <span>
                      PROJETO (
                      {statusProgress(proj?.stages?.sort(maisatual)[0]?.title)}
                      %)
                    </span>
                    <div className="div__status_project" />
                  </div>

                  {proj.suspended ||
                  proj.finished_at ||
                  proj.stages.length === 0 ? (
                    <div className="barra_progresso">
                      <span style={{ marginTop: '1rem' }}>Situação</span>
                    </div>
                  ) : (
                    <div className="barra_progresso">
                      {proj?.stages && (
                        <span style={{ marginTop: '1rem' }}>
                          {proj?.stages.sort(maisatual)[0].title} <br />
                          (há{' '}
                          {differenceInDays(
                            new Date(),
                            new Date(
                              proj?.stages.sort(maisatual)[0]?.created_at
                            )
                          )}{' '}
                          dias)
                          <br />
                          Estimativa:{' '}
                          {differenceInDays(
                            new Date(proj?.stages.sort(maisatual)[0]?.deadline),
                            new Date(
                              proj?.stages.sort(maisatual)[0]?.created_at
                            )
                          )}{' '}
                          dias
                          {}
                        </span>
                      )}
                      <div className="div__status_process" />
                    </div>
                  )}

                  <div className="barra_progresso">
                    <span />
                    {(() => {
                      const stages = Array.isArray(proj?.stages)
                        ? proj.stages
                        : [];
                      const latestStage = stages.length
                        ? [...stages].sort(maisatual)[0]
                        : undefined;

                      if (proj?.finished_at) {
                        if (latestStage?.title === '5 - Projeto aprovado') {
                          return (
                            <div className="div__description">
                              PROJETO APROVADO
                            </div>
                          );
                        }
                        if (latestStage?.title === '7 - Projeto reprovado') {
                          return (
                            <div className="div__description">
                              PROJETO REPROVADO
                            </div>
                          );
                        }
                        return (
                          <div className="div__description">
                            PROJETO FINALIZADO
                          </div>
                        );
                      }

                      if (proj?.suspended) {
                        return (
                          <div className="div__description">
                            PROJETO SUSPENSO
                          </div>
                        );
                      }

                      if (!proj.stages[0]?.deadline) {
                        return (
                          <div className="div__description">
                            PROJETO AGUARDANDO APROVAÇÃO DA CONCESSIONÁRIA
                          </div>
                        );
                      }

                      if (!stages.length) {
                        return (
                          <div className="div__description">
                            PROJETO AGUARDANDO APROVAÇÃO DA CONCESSIONÁRIA
                          </div>
                        );
                      }

                      const desc = latestStage?.description;
                      return (
                        <div className="div__description">
                          {desc ? `DESCRIÇÃO: ${desc}` : 'Sem descrição'}
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </Card>
            ))}

            {listidx <
            // filterProjects?.filter(
            //   (proj) => proj.deadline && proj.stages.length !== 0
            //   // && proj.responsibles.length !== 0,
            // ).length ? (
            filterProjects?.length ? (
              <div
                className="div__viewMore"
                onClick={() => setListidx(listidx + 3)}
              >
                Ver mais
              </div>
            ) : filterProjects?.length === 0 && filter.type ? (
              <div style={{ margin: '2rem 1rem' }}>
                Nenhum projeto encontrado
              </div>
            ) : filterProjects?.length === 0 && !filter.type ? (
              <div style={{ margin: '2rem 1rem' }}>
                Nenhum projeto cadastrado
              </div>
            ) : (
              <div style={{ margin: '2rem 1rem' }}>Sem mais Projetos</div>
            )}
          </div>
        </content>
      </Page>

      {showconf.status && (
        <Dialogoconfirmacao
          status={showconf.status}
          width={showconf.width}
          delete={showconf.delete}
          description={showconf.description}
          fechar={() =>
            setShowconf({
              status: false,
              width: 'sm',
              title: 'Confirmar',
              description: 'Deseja realmente suspender este projeto?',
              btn_conf: 'Sim',
              btn_cancel: 'Não',
              delete: true,
              dados: '',
            })
          }
          confirmar={() => {
            if (showconf.type === 'PATCH_PROJECTS_BY_ID') {
              if (showconf.dados.suspended) {
                PATCH_PROJECTS_BY_ID(
                  showconf.dados.id,
                  async () => {
                    let params = {
                      is_approved:
                        user?.role === 'ADMINISTRADOR' ? true : false,
                    };

                    await GET_PROJECTS_BY_INTEGRATOR(
                      id,
                      setListProjects,
                      setShowbackdrop,
                      params
                    );
                  },
                  setShowbackdrop
                );
                toast.success(
                  `Projeto ${showconf.dados.client_name} retomado com sucesso`
                );
              } else {
                PATCH_PROJECTS_BY_ID(
                  showconf.dados.id,
                  () => {
                    let params = {
                      is_approved:
                        user?.role === 'ADMINISTRADOR' ? true : false,
                    };

                    GET_PROJECTS_BY_INTEGRATOR(
                      id,
                      setListProjects,
                      setShowbackdrop,
                      params
                    );
                  },
                  setShowbackdrop
                );
                toast.info(
                  `Projeto de ${showconf.dados.client_name} suspenso com sucesso`
                );
              }
            } else if (showconf.type === 'SET_PAYMENT_ID') {
              const last = getLastReceipt(showconf.dados);
              const receiptId = last?.id;

              SET_PAYMENT_ID(receiptId, () => {
                handleProjectPaymentUpdated(showconf.dados.id, receiptId, true);

                let params = {
                  is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
                };

                GET_PROJECTS_BY_INTEGRATOR(
                  id,
                  setListProjects,
                  setShowbackdrop,
                  params
                );

                setShowconf({
                  status: false,
                  width: 'sm',
                  title: 'Confirmar',
                  description: 'Deseja realmente suspender este projeto?',
                  btn_conf: 'Sim',
                  btn_cancel: 'Não',
                  delete: true,
                  dados: '',
                });
              });
            } else if (showconf.type === 'SET_CANCEL_PAYMENT_ID') {
              const last = getLastReceipt(showconf.dados);
              const receiptId = last?.id;

              SET_CANCEL_PAYMENT_ID(receiptId, () => {
                handleProjectPaymentUpdated(
                  showconf.dados.id,
                  receiptId,
                  false
                );

                let params = {
                  is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
                };

                GET_PROJECTS_BY_INTEGRATOR(
                  id,
                  setListProjects,
                  setShowbackdrop,
                  params
                );

                setShowconf({
                  status: false,
                  width: 'sm',
                  title: 'Confirmar',
                  description: 'Deseja realmente suspender este projeto?',
                  btn_conf: 'Sim',
                  btn_cancel: 'Não',
                  delete: true,
                  dados: '',
                });
              });
            } else if (showconf.type === 'SET_FINISH_PROJECT') {
              PATCH_FINISHED_PROJECT(
                showconf.dados.id,
                { finished_at: new Date().toISOString() },
                async () => {
                  let params = {
                    is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
                  };

                  await GET_PROJECTS_BY_INTEGRATOR(
                    id,
                    setListProjects,
                    setShowbackdrop,
                    params
                  );
                },
                setShowbackdrop
              );
              toast.success('Projeto finalizado com sucesso!');
              setShowconf({
                status: false,
                width: 'sm',
                title: 'Confirmar',
                description: 'Deseja realmente suspender este projeto?',
                btn_conf: 'Sim',
                btn_cancel: 'Não',
                delete: true,
                dados: '',
                type: '',
              });
            } else if (showconf.type === 'SET_OPEN_PROJECT') {
              PATCH_FINISHED_PROJECT(
                showconf.dados.id,
                { finished_at: null },
                async () => {
                  let params = {
                    is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
                  };
                  await GET_PROJECTS_BY_INTEGRATOR(
                    id,
                    setListProjects,
                    setShowbackdrop,
                    params
                  );
                },
                setShowbackdrop
              );
              toast.success('Projeto reaberto com sucesso!');
              setShowconf({
                status: false,
                width: 'sm',
                title: 'Confirmar',
                description: 'Deseja realmente suspender este projeto?',
                btn_conf: 'Sim',
                btn_cancel: 'Não',
                delete: true,
                dados: '',
                type: '',
              });
            }
          }}
        />
      )}

      {showconfdesvincular.status && (
        <Dialogoconfirmacao
          status={showconfdesvincular.status}
          width={showconfdesvincular.width}
          delete={showconfdesvincular.delete}
          description={showconfdesvincular.description}
          fechar={() =>
            setShowconfdesvincular({
              status: false,
              width: 'sm',
              title: 'Confirmar',
              description: 'Deseja realmente suspender este projeto?',
              btn_conf: 'Sim',
              btn_cancel: 'Não',
              delete: true,
              dados: '',
              type: 'DELETE_RESPONSIBLES',
            })
          }
          confirmar={async () => {
            await DELETE_RESPONSIBLES(
              showconfdesvincular.dados.responsibles[0].id,
              async () => {
                let params = {
                  is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
                };

                await GET_PROJECTS_BY_INTEGRATOR(
                  id,
                  setListProjects,
                  setShowbackdrop,
                  params
                );
              },
              setShowbackdrop
            );
          }}
        />
      )}

      {viewcadastrarsupervisor.status && (
        <Dialogoadicionarsupervisor
          dados={viewcadastrarsupervisor.dados}
          fechar={() =>
            setViewcadastrarsupervisor({ status: false, dados: '' })
          }
          atualizar={async () => {
            let params = {
              is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
            };

            await GET_PROJECTS_BY_INTEGRATOR(
              id,
              setListProjects,
              setShowbackdrop,
              params
            );
          }}
        />
      )}

      {viewedit.status && (
        <Dialogoverificaralteracao
          dados={viewedit.dados}
          dados_proj={viewedit.dados_proj}
          fechar={() =>
            setViewedit({ status: false, dados: '', dados_proj: '' })
          }
          edit={setViewproject}
          atualizar={async () => {
            let params = {
              is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
            };

            await GET_PROJECTS_BY_INTEGRATOR(
              id,
              setListProjects,
              setShowbackdrop,
              params
            );
          }}
        />
      )}

      {editProject.status && (
        <BaseDialogEditProject
          dados={editProject.dados}
          fechar={() => setEditProject({ status: false, dados: '' })}
          atualizar={async () => {
            let params = {
              is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
            };

            await GET_PROJECTS_BY_INTEGRATOR(
              id,
              setListProjects,
              setShowbackdrop,
              params
            )
          }}
          onProjectPixUpdated={handleProjectPixUpdated}
          onProjectPaymentUpdated={handleProjectPaymentUpdated}
        />
      )}

      {viewproject.status && (
        // <Dialogoverprojeto
        //   dados={viewproject.dados}
        //   dados_edit={viewproject?.dados_edit}
        //   fechar={() => setViewproject({ status: false, dados: '' })}
        //   atualizar={async () =>
        //     await GET_PROJECTS_BY_INTEGRATOR(id, setListProjects)
        //   }
        //   onProjectPixUpdated={handleProjectPixUpdated}
        //   onProjectPaymentUpdated={handleProjectPaymentUpdated}
        // />
        <BaseDialogShowProject
          dados={viewproject.dados}
          dados_edit={viewproject?.dados_edit}
          fechar={() => setViewproject({ status: false, dados: '' })}
        />
      )}

      {solicitarmud.status && (
        <Chatbox
          fechar={() => setSolicitarmud({ status: false, dados: '' })}
          dados={solicitarmud.dados}
          disabledOptions={
            !solicitarmud.dados.refused &&
            solicitarmud.dados.stages?.length <= 0
          }
          atualizar={async () => {
            let params = {
              is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
            };

            await GET_PROJECTS_BY_INTEGRATOR(
              id,
              setListProjects,
              setShowbackdrop,
              params
            )
          }}
        />
      )}

      {showbackdrop && <SimpleBackdrop />}
    </Container>
  );
}

export default Projetos;
